import { GiCheckMark } from "react-icons/gi";
import { CiBank } from "react-icons/ci";
import "../Home/Home.css"

const Home = () => {
    return (
        <>
            {/* for crsoule section */}
            <div className="container-fluid" id="home-bg">
                <div className="row">
                    <div id="carouselExampleCaptions" className="carousel slide">
                        <div className="carousel-inner">
                            {/* first carosoule */}
                            <div className="carousel-item active">                             
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <img  src="/images/1.png" className="d-block w-100" />
                                    </div>
                                    <div className="col-lg-6 .d-sm-none .d-md-block">
                                        <div className="" id="carousel-content">
                                            <h5 id="carousel-heading">First slide label</h5>
                                            <p id="carousel-para">
                                                Some representative placeholder content for the first
                                                slide.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* 2nd carosoule */}
                            <div className="carousel-item">
                                <div className="row">
                                    <div className="col-lg-6 .d-sm-none .d-md-block">
                                        <div className="ms-5" id="carousel-content">
                                            <h5 id="carousel-heading">First slide label</h5>
                                            <p id="carousel-para">
                                                Some representative placeholder content for the first
                                                slide.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <img  src="/images/2.png" className="d-block w-100" />
                                    </div>
                                </div>
                            </div>
                            {/* 3rd carousoule */}
                            <div className="carousel-item">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <img  src="/images/3.png" className="d-block w-100" />
                                    </div>
                                    <div className="col-lg-6 .d-sm-none .d-md-block">
                                        <div className="" id="carousel-content">
                                            <h5 id="carousel-heading">First slide label</h5>
                                            <p id="carousel-para">
                                                Some representative placeholder content for the first
                                                slide.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button
                            className="carousel-control-prev"
                            type="button"
                            data-bs-target="#carouselExampleCaptions"
                            data-bs-slide="prev"
                            id="prev-btn"
                        >
                            <span
                                className="carousel-control-prev-icon"
                                aria-hidden="true"
                            ></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button
                            className="carousel-control-next"
                            type="button"
                            data-bs-target="#carouselExampleCaptions"
                            data-bs-slide="next"
                            id="next-btn"
                        >
                            <span
                                className="carousel-control-next-icon"
                                aria-hidden="true"
                            ></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>
            </div>

            <div className="container mt-5">
                <div className="row">
                    <div className="col-xl-4">
                        <div className="cloud-card">
                            <h5 className="text-center">Games</h5>
                            <p>
                                Game in early childhood is the best foundation for
                                success in school. It develops all necessary learning
                                skills.
                            </p>
                            <div className="text-center">
                                <button className="card-button">More</button>
                            </div>
                        </div>
                    </div> 
                    <div className="col-xl-4">
                        <div className="cloud-card">
                            <div className="cloud-shape">
                                <div className="cloud-text">
                                    <h5 className="text-center">Activities</h5>
                                    <p>
                                        Our activities will challenge and develop your child’s
                                        creativity, imagination, thinking skills, and social
                                        skills.
                                    </p>
                                    <div className="text-center">
                                        <button className="card-button">More</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div className="col-xl-4">
                        <div className="cloud-card">
                            <div className="cloud-shape">
                                <div className="cloud-text">
                                    <h5 className="text-center">Education</h5>
                                    <p>
                                        Our center provides many educational activities to keep
                                        your kids engaged. They learn when playing.
                                    </p>
                                    <div className="text-center">
                                        <button className="card-button">More</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* home -3 */}
            <div className="container py-2 mt-5">
                <div className="row ">
                    <div className="col-xl-8">
                        <div className="home-three-text">
                            <h2 className="mt-5 mb-4">
                                A Few Words About{" "}
                                <span className="home-three-span">Our Prechool</span>{" "}
                            </h2>
                            <p>
                                Libero commodo, ornare mi id, egestas metus. Vivamus condimentum
                                elit vel vestibulum feugiat Aliquam semper nunc augue, vitae
                                fringilla felis adipiscing ac. Duis convallis nibh at euismod
                                molestie.
                            </p>
                            <p>
                                <GiCheckMark className="check-icons" />
                                Aenean tincidunt laoreet odio at vulputate, sed pretium lorem
                                sed nulla pulvinar gravida
                            </p>
                            <p>
                                <GiCheckMark className="check-icons" />
                                Aenean tincidunt laoreet odio at vulputate, sed pretium lorem
                                sed nulla pulvinar gravida
                            </p>
                            <p>
                                <GiCheckMark className="check-icons" />
                                Aenean tincidunt laoreet odio at vulputate, sed pretium lorem
                                sed nulla pulvinar gravida
                            </p>
                        </div>
                        <div className="mt-5 mb-5">
                            <button className="card-button">More About us</button>
                        </div>
                    </div>
                    <div className="col-xl-4">
                        <div className="home-three-image">
                            <img src="/images/4.png" className="d-block w-100" alt="..." />
                        </div>
                    </div>
                </div>
            </div>
            <div className="main-line mt-2 mb-2">
                <div className="line"></div>
            </div>

            {/* home-4 section */}
            <div className="container mt-5">
                <div className="row">
                    <div className="col-12 text-center mb-5">
                        <div className="home-three-text">
                            <h2>
                                Our Preschool provides{" "}
                                <span className="home-three-span">the following services</span>
                            </h2>
                        </div>
                    </div>

                    <div className="col-xl-4 col-md-6 mb-4">
                        <div className="service-box">
                            <div className="home-icons">
                                <CiBank />
                            </div>
                            <h6 className="service-title">Learn through play</h6>
                            <p className="service-description">
                                Mi id egestas metus neus, vivamus condimentum elit.
                            </p>
                        </div>
                        <div className="service-box mt-3">
                            <div className="home-icons">
                                <CiBank />
                            </div>
                            <h6 className="service-title">Learn through play</h6>
                            <p className="service-description">
                                Mi id egestas metus neus, vivamus condimentum elit.
                            </p>
                        </div>
                    </div>

                    <div className="col-xl-4 col-md-6 mb-4">
                        <div className="service-box">
                            <div className="home-icons">
                                <CiBank />
                            </div>
                            <h6 className="service-title">Learn through play</h6>
                            <p className="service-description">
                                Mi id egestas metus neus, vivamus condimentum elit.
                            </p>
                        </div>
                        <div className="service-box mt-3">
                            <div className="home-icons">
                                <CiBank />
                            </div>
                            <h6 className="service-title">Learn through play</h6>
                            <p className="service-description">
                                Mi id egestas metus neus, vivamus condimentum elit.
                            </p>
                        </div>
                    </div>

                    <div className="col-xl-4 col-md-6 mb-4">
                        <div className="service-box">
                            <div className="home-icons">
                                <CiBank />
                            </div>
                            <h6 className="service-title">Learn through play</h6>
                            <p className="service-description">
                                Mi id egestas metus neus, vivamus condimentum elit.
                            </p>
                        </div>
                        <div className="service-box mt-3">
                            <div className="home-icons">
                                <CiBank />
                            </div>
                            <h6 className="service-title">Learn through play</h6>
                            <p className="service-description">
                                Mi id egestas metus neus, vivamus condimentum elit.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {/* ---------------------------------------Line-------------------- */}
            {/* home -4 */}
            <div className="main-line mt-2 mb-2">
                <div className="line"></div>
            </div>
            {/* ------------------------------------------------------------------- */}
            <div className="container mt-5">
                <div className="row">
                    {/* <!-- Title Section --> */}
                    <div className="col-12 text-center mb-3">
                        <div className="home-three-text">
                            <h2>
                                We are <span className="home-three-span">Kiddy </span>
                                Children Gallery
                            </h2>
                        </div>
                    </div>

                    {/* <!-- Paragraph Section --> */}
                    <div className="col-12 text-center mb-3">
                        <p>
                            Libero commodo, ornare mi id, egestas metus. Vivamus condimentum<br />
                            elit vel vestibulum feugiat Aliquam semper nunc augue, vitae
                            fringilla felis adipiscing ac.
                        </p>
                    </div>

                    {/* <!-- Buttons Section --> */}
                    <div className="col-12 d-flex justify-content-center">
                        <button className="card-button bg-info mx-2 mb-3 mb-md-0">
                            Purchase Now
                        </button>
                        <button className="card-button mx-2 mb-3 mb-md-0">
                            Learn More
                        </button>
                    </div>
                </div>
            </div>
            {/* ------------------------------------------------------------------------ */}

            <div class="container mt-5">
                <div class="row">
                    {/* <!-- Card 1 --> */}
                    <div class="col-xl-4 col-lg-4 col-md-6 col-12 mb-4">
                        <div class="card custom-card h-100">
                            <img src="/images/6.png" class="card-img-top" alt="Card image" />
                            <div class="card-body">
                                <h5 class="card-title">Gallery Item 1</h5>
                                <p class="card-text">
                                    This is a description of the gallery item. You can add more
                                    content here.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 col-12 mb-4">
                        <div class="card custom-card h-100">
                            <img src="/images/8.png" class="card-img-top" alt="Card image" />
                            <div class="card-body">
                                <h5 class="card-title">Gallery Item 1</h5>
                                <p class="card-text">
                                    This is a description of the gallery item. You can add more
                                    content here.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Card 2 --> */}
                    <div class="col-xl-4 col-lg-4 col-md-6 col-12 mb-4">
                        <div class="card custom-card h-100">
                            <img src="/images/6.png" class="card-img-top" alt="Card image" />
                            <div class="card-body">
                                <h5 class="card-title">Gallery Item 2</h5>
                                <p class="card-text">
                                    This is a description of the gallery item. You can add more
                                    content here.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 col-12 mb-4">
                        <div class="card custom-card h-100">
                            <img src="/images/8.png" class="card-img-top" alt="Card image" />
                            <div class="card-body">
                                <h5 class="card-title">Gallery Item 2</h5>
                                <p class="card-text">
                                    This is a description of the gallery item. You can add more
                                    content here.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* <!-- Card 3 --> */}
                    <div class="col-xl-4 col-lg-4 col-md-6 col-12 mb-4">
                        <div class="card custom-card h-100">
                            <img src="/images/6.png" class="card-img-top" alt="Card image" />
                            <div class="card-body">
                                <h5 class="card-title">Gallery Item 3</h5>
                                <p class="card-text">
                                    This is a description of the gallery item. You can add more
                                    content here.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-6 col-12 mb-4">
                        <div class="card custom-card h-100">
                            <img src="/images/8.png" class="card-img-top" alt="Card image" />
                            <div class="card-body">
                                <h5 class="card-title">Gallery Item 3</h5>
                                <p class="card-text">
                                    This is a description of the gallery item. You can add more
                                    content here.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ----------------------------------------------------- */}
            <div className="container-fluid mt-4"
                style={{
                    backgroundImage: 'url("/images/10.jpg")',
                    backgroundSize: 'cover',
                    height: '40vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center'
                }}
            >
                <div className="row">
                    <div className="col-xl-12">
                        <h4 className="ms-4 me-4 custom-h4-margin">Want to get more information about our learning center or would like to see it inside, feel free to schedule a tour.
                            Come visit us today!</h4>
                        <div className="button-container mt-3">
                            <button className="card-button">More About us</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Home;